"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryDocumentChange = void 0;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const common_1 = require("../../src/document/command/common");
const arbitraryOperation = fast_check_1.default.constantFrom(common_1.CommandType.addElementCommand, common_1.CommandType.updatePcbNodesCommand, common_1.CommandType.removePcbNodesCommand);
const arbitraryDocumentBaseDataChange = (constraints = {}) => {
    return fast_check_1.default.record({
        kind: fast_check_1.default.constantFrom("baseData"),
        payload: constraints.payload ? fast_check_1.default.constant(constraints.payload) : fast_check_1.default.record({}),
    });
};
const arbitraryDocumentCollectionChange = (constraints = {}) => {
    return fast_check_1.default.record({
        kind: fast_check_1.default.constantFrom("subCollection"),
        payload: constraints.payload ? fast_check_1.default.constant(constraints.payload) : fast_check_1.default.record({}),
    });
};
const withArbitraryCommand = (arbitraryChange, constraints = {}) => {
    return fast_check_1.default
        .tuple(arbitraryChange, constraints.command ? fast_check_1.default.constant(constraints.command) : arbitraryOperation)
        .map(([documentChange, command]) => {
        return { ...documentChange, command };
    });
};
const arbitraryDocumentChange = (constraints = {}) => {
    if (constraints.kind === "baseData") {
        return withArbitraryCommand(arbitraryDocumentBaseDataChange(constraints), constraints);
    }
    else if (constraints.kind === "subCollection") {
        return withArbitraryCommand(arbitraryDocumentCollectionChange(constraints), constraints);
    }
    else {
        return withArbitraryCommand(fast_check_1.default.oneof(arbitraryDocumentBaseDataChange(), arbitraryDocumentCollectionChange()), constraints);
    }
};
exports.arbitraryDocumentChange = arbitraryDocumentChange;
//# sourceMappingURL=change.js.map